import PopColorPicker from 'src/components/common/form-elements/ColorPicker'
import FloRadioGroup from 'src/components/common/form-elements/FloRadioGroup'
import { useRewardsContext } from 'src/lib/contexts/RewardsConfigContext'
import { CreditNameVisibiltyOptions, OutlineOptions } from './EarnTileCustomiseConfig'
import { useLocale } from 'src/lib/hooks/useLocal'
import { useRewardsPermissions } from 'src/lib/access-permission-hooks/useRewardsPermissions'

const EarnTileCustomiseUI = () => {
  const { t } = useLocale()
  const earnTileCustomisation = useRewardsContext(context => context?.state?.earnTileCustomiseUi)
  const setEarnTileCustomisation = useRewardsContext(context => context?.actions?.setEarnTileCustomisation)

  const { canEditRewardsCustomisation } = useRewardsPermissions()
  return (
    <div className=' flex flex-col gap-4'>
      <div className='border-t-1 pb-2 -mx-4'></div>
      <div className='flex flex-col gap-2'>
        <h2 className='text-base font-medium text-coal-dark'>{t('colors')}</h2>
        <div className='flex flex-row gap-6'>
          <PopColorPicker
            isDisabled={!canEditRewardsCustomisation}
            label={'Text'}
            themeColor={earnTileCustomisation?.textColor}
            setThemeColor={(color: string) => {
              setEarnTileCustomisation({ ...earnTileCustomisation, textColor: color })
            }}
          />
          <PopColorPicker
            isDisabled={!canEditRewardsCustomisation}
            label={'Outline'}
            themeColor={earnTileCustomisation?.outlineColor}
            setThemeColor={(color: string) => {
              setEarnTileCustomisation({ ...earnTileCustomisation, outlineColor: color })
            }}
          />
          <PopColorPicker
            isDisabled={!canEditRewardsCustomisation}
            label={'Background'}
            themeColor={earnTileCustomisation?.backgroundColor}
            setThemeColor={(color: string) => {
              setEarnTileCustomisation({ ...earnTileCustomisation, backgroundColor: color })
            }}
          />
        </div>
      </div>
      <div className='gap-2'>
        <h2 className='text-base font-medium text-coal-dark'>{'Credit Name'}</h2>
        <FloRadioGroup
          isDisabled={!canEditRewardsCustomisation}
          groupName={'Credit Name Visibility'}
          options={CreditNameVisibiltyOptions}
          selectedOption={earnTileCustomisation?.isCreditNameVisible}
          setSelectedOption={(radioSelectedOption: string) => {
            setEarnTileCustomisation({ ...earnTileCustomisation, isCreditNameVisible: radioSelectedOption })
          }}
          customClassName='pt-1 text-coal-dark'
        />
      </div>
      <div className='gap-2'>
        <h2 className='text-base font-medium text-coal-dark'>{'Outline'}</h2>
        <FloRadioGroup
          isDisabled={!canEditRewardsCustomisation}
          groupName={'Outline'}
          options={OutlineOptions}
          selectedOption={earnTileCustomisation?.outline}
          setSelectedOption={(radioSelectedOption: string) => {
            setEarnTileCustomisation({ ...earnTileCustomisation, outline: radioSelectedOption })
          }}
          customClassName='pt-1 text-coal-dark flex flex-row gap-2'
        />
      </div>
    </div>
  )
}

export default EarnTileCustomiseUI
